var _clipPath;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBootstrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 170 120",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "bootstrap.98585727bcfe0b1555649ec9bbab236c.svg",
    transform: "matrix(0.0508853,0,0,0.0508853,85.1186,59.7481)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1250,-996)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "_clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 2500,
    height: 1992
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.258,0.238C376.611,0.238 271.06,125.092 275.786,260.492C280.322,390.575 274.429,559.052 232.017,696.444C189.453,834.223 117.52,921.532 -0,932.738L-0,1059.26C117.52,1070.49 189.453,1157.76 232.012,1295.56C274.429,1432.95 280.317,1601.42 275.781,1731.51C271.055,1866.89 376.606,1991.76 519.277,1991.76L1980.93,1991.76C2123.58,1991.76 2229.11,1866.91 2224.39,1731.51C2219.85,1601.42 2225.74,1432.95 2268.15,1295.56C2310.72,1157.76 2382.48,1070.46 2500,1059.26L2500,932.738C2382.48,921.508 2310.72,834.242 2268.15,696.444C2225.74,559.071 2219.85,390.575 2224.39,260.492C2229.11,125.111 2123.58,0.238 1980.93,0.238L519.238,0.238L519.258,0.238ZM1694.92,1226.15C1694.92,1412.59 1555.85,1525.66 1325.06,1525.66L932.202,1525.66C908.957,1525.66 889.829,1506.54 889.829,1483.29L889.829,508.715C889.829,485.47 908.957,466.342 932.202,466.342L1322.83,466.342C1515.26,466.342 1641.56,570.58 1641.56,730.619C1641.56,842.948 1556.6,943.51 1448.36,961.127L1448.36,966.986C1595.7,983.148 1694.92,1085.2 1694.92,1226.15ZM1282.23,600.663L1058.22,600.663L1058.22,917.069L1246.89,917.069C1392.74,917.069 1473.16,858.339 1473.16,753.363C1473.14,654.984 1404,600.663 1282.23,600.663ZM1058.22,1042.59L1058.22,1391.3L1290.47,1391.3C1442.32,1391.3 1522.76,1330.37 1522.76,1215.85C1522.76,1101.34 1440.07,1042.59 1280.7,1042.59L1058.22,1042.59Z",
    style: {
      fill: "rgb(121,82,179)"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrap);
export default __webpack_public_path__ + "static/media/bootstrap.a42844afdf6bfebe5130d86fa6044ff8.svg";
export { ForwardRef as ReactComponent };